@if (!parameter.IsFixed) {
  <div class="padding">
    @switch (parameter.Type) {
      @case ('String') {
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
          <abc-text-box
            (onChange)="onTextValueChange($event, parameter.Name, parameter.Value)"
            label="{{ parameter.Caption ? parameter.Caption : parameter.Name }}"
            labelMode="floating"
            placeholder="{{ parameter.Value }}"
            [(value)]="parameter.Value"
            [width]="'100%'"
            >
          </abc-text-box>
        </div>
      }
      @case ('Boolean') {
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
          <abc-check-box (onValueChanged)="onCheckboxValueChange($event, parameter.Name)" [(value)]="parameter.Value">
          </abc-check-box>
          <label>
            @if (parameter.Caption) {
              <span>{{ parameter.Caption }}</span>
            } @else {
              {{ parameter.Name }}
            }
          </label>
        </div>
      }
      @case ('Date') {
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
          <abc-date-box
            (onChange)="onDateValueChange($event, parameter.Name, parameter.Value)"
            label="{{ parameter.Caption ? parameter.Caption : parameter.Name }}"
            labelMode="floating"
            placeholder="{{ parameter.Value }}"
            [(value)]="parameter.Value"
            [pickerType]="'calendar'"
            [width]="'100%'"
            >
          </abc-date-box>
        </div>
      }
      @case ('Number') {
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
          <abc-number-box
            (onChange)="onNumberValueChange($event, parameter.Name, parameter.Value)"
            label="{{ parameter.Caption ? parameter.Caption : parameter.Name }}"
            labelMode="floating"
            placeholder="{{ parameter.Value }}"
            [(value)]="parameter.Value"
            [width]="'100%'"
            >
          </abc-number-box>
        </div>
      }
      @case ('ValueExpression') {
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
          <abc-text-box
            (onChange)="onValueExpressionChange($event, parameter.Name)"
            label="{{ parameter.Caption ? parameter.Caption : parameter.Name }}"
            labelMode="floating"
            [(value)]="valueExpression"
            [width]="'100%'"
            >
          </abc-text-box>
          <span><small style="color: darkred">ValueExpression.Value</small></span>
        </div>
      }
      @case ('PicklistByName') {
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
          @if (!parameter.AllowMultiSelect) {
            <abc-drop-down-box
              [dataSource]="picklistByNameData"
              [visible]="true"
              (onValueChanged)="onPicklistByNameSingleSelectionChange($event, parameter.Name)"
              label="{{ parameter.Caption ? parameter.Caption : parameter.Name }}"
              labelMode="floating"
              [width]="'100%'"
              [displayExpr]="'Value'"
              [valueExpr]="'Value'"
      [gridColumns]="[
        { dataField: 'Value', name: res.get('ValuesEditorComponentColumn-Value') },
        { dataField: 'Description', name: res.get('ValuesEditorComponentColumn-Description') }
      ]"
              >
            </abc-drop-down-box>
          }
          @if (parameter.AllowMultiSelect) {
            <abc-grid
              [showBorders]="true"
              [showRowLines]="true"
              [showColumnLines]="true"
              [dataSource]="picklistByNameData"
              (onSelectionChanged)="onPicklistByNameMultipleSelectionChange($event, parameter.Name)"
              [width]="'100%'"
      [selection]="{
        allowSelectAll: true,
        deferred: false,
        mode: 'multiple',
        selectAllMode: 'allPages',
        showCheckBoxesMode: 'always'
      }"
              [filterRow]="{ visible: true }"
              [visible]="true"
              [height]="isPicklistByNameScrolling ? '520' : '100%'"
              [rowAlternationEnabled]="true"
              [paging]="{ enabled: false }"
      [columns]="[
        { dataField: 'Value', caption: res.get('ValuesEditorComponentColumn-Value') },
        { dataField: 'Description', caption: res.get('ValuesEditorComponentColumn-Description') }
      ]"
              [allowColumnResizing]="true"
              [hoverStateEnabled]="true"
              >
            </abc-grid>
          }
        </div>
      }
      @case ('PicklistByColumn') {
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
          @if (!parameter.AllowMultiSelect) {
            <abc-drop-down-box
              [dataSource]="picklistByColumnData"
              [visible]="true"
              (onValueChanged)="onPicklistByColumnSingleSelectionChange($event, parameter.Name)"
              label="{{ parameter.Caption ? parameter.Caption : parameter.Name }}"
              labelMode="floating"
              [width]="'100%'"
              [displayExpr]="'Value'"
              [valueExpr]="'Value'"
      [gridColumns]="[
        { dataField: 'Value', name: res.get('ValuesEditorComponentColumn-Value') },
        { dataField: 'Description', name: res.get('ValuesEditorComponentColumn-Description') }
      ]"
              >
            </abc-drop-down-box>
          }
          @if (parameter.AllowMultiSelect) {
            <abc-grid
              [showBorders]="true"
              [showRowLines]="true"
              [showColumnLines]="true"
              [dataSource]="picklistByColumnData"
              (onSelectionChanged)="onPicklistByColumnMultipleSelectionChange($event, parameter.Name)"
              [width]="'100%'"
      [selection]="{
        allowSelectAll: true,
        deferred: false,
        mode: 'multiple',
        selectAllMode: 'allPages',
        showCheckBoxesMode: 'always'
      }"
              [filterRow]="{ visible: true }"
              [visible]="true"
              [height]="isPicklistByColumnScrolling ? '520' : '100%'"
              [rowAlternationEnabled]="true"
              [paging]="{ enabled: false }"
      [columns]="[
        { dataField: 'Value', caption: res.get('ValuesEditorComponentColumn-Value') },
        { dataField: 'Description', caption: res.get('ValuesEditorComponentColumn-Description') }
      ]"
              [allowColumnResizing]="true"
              [hoverStateEnabled]="true"
              >
            </abc-grid>
          }
        </div>
      }
      @case ('DataAccessByValue') {
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
          @if (!parameter.AllowMultiSelect) {
            <abc-select-box
              [dataSource]="valueSingleSelectionData"
              [visible]="true"
              (onSelectionChanged)="onValueSingleSelectionChange($event, parameter.Name)"
              label="{{ parameter.Caption ? parameter.Caption : parameter.Name }}"
              labelMode="floating"
              [width]="'100%'"
              >
            </abc-select-box>
          }
          @if (parameter.AllowMultiSelect) {
            <abc-grid
              [showBorders]="true"
              [showRowLines]="true"
              [showColumnLines]="true"
              [dataSource]="valueMultipleSelectionData"
              (onSelectionChanged)="onValueMultipleSelectionChange($event, parameter.Name)"
              [width]="'100%'"
      [selection]="{
        allowSelectAll: true,
        deferred: false,
        mode: 'multiple',
        selectAllMode: 'allPages',
        showCheckBoxesMode: 'always'
      }"
              [filterRow]="{ visible: true }"
              [visible]="true"
              [height]="isDataAccessByValueScrolling ? '520' : '100%'"
              [rowAlternationEnabled]="true"
              [paging]="{ enabled: false }"
              [columns]="[{ dataField: parameter.DataArgument2, caption: res.get('ValuesEditorComponentColumn-Value') }]"
              [hoverStateEnabled]="true"
              >
            </abc-grid>
          }
        </div>
      }
      @case ('DataAccessByObjectType') {
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
          @if (!parameter.AllowMultiSelect) {
            <abc-drop-down-box
              [dataSource]="objectSelectionData"
              (onValueChanged)="objectSingleSelectionChange($event, parameter.Name)"
              [width]="'100%'"
      [selection]="{
        allowSelectAll: false,
        deferred: true,
        mode: 'single',
        selectAllMode: 'allPages',
        showCheckBoxesMode: 'onClick'
      }"
              [filterRow]="{ visible: true }"
              [visible]="true"
              label="{{ parameter.Caption ? parameter.Caption : parameter.Name }}"
              labelMode="floating"
              [displayExpr]="objectSelectionColumnName"
              [valueExpr]="'Id'"
              [gridColumns]="objectSelectionColumns"
              >
            </abc-drop-down-box>
          }
          @if (parameter.AllowMultiSelect) {
            <abc-grid
              [showBorders]="true"
              [showRowLines]="true"
              [showColumnLines]="true"
              [dataSource]="objectSelectionData"
              (onSelectionChanged)="objectMultipleSelectionChange($event, parameter.Name)"
              [width]="'100%'"
      [selection]="{
        allowSelectAll: true,
        deferred: false,
        mode: 'multiple',
        selectAllMode: 'allPages',
        showCheckBoxesMode: 'always'
      }"
              [filterRow]="{ visible: true }"
              [visible]="true"
              [columns]="objectSelectionColumns"
              [height]="isDataAccessByObjectTypeScrolling ? '520' : '100%'"
              [rowAlternationEnabled]="true"
              [paging]="{ enabled: false }"
              [hoverStateEnabled]="true"
              >
            </abc-grid>
          }
        </div>
      }
      @case ('Query') {
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
          @if (!parameter.AllowMultiSelect) {
            <abc-drop-down-box
              [dataSource]="queryData"
              (onValueChanged)="querySingleSelectionChange($event, parameter.Name)"
              [width]="'100%'"
      [selection]="{
        allowSelectAll: false,
        deferred: true,
        mode: 'single',
        selectAllMode: 'allPages',
        showCheckBoxesMode: 'onClick'
      }"
              [filterRow]="{ visible: true }"
              [visible]="true"
              label="{{ parameter.Caption ? parameter.Caption : parameter.Name }}"
              labelMode="floating"
              [displayExpr]="parameter.DataArgument2"
              [valueExpr]="parameter.DataArgument2"
              [gridColumns]="queryColumns"
              >
            </abc-drop-down-box>
          }
          @if (parameter.AllowMultiSelect) {
            <abc-grid
              [showBorders]="true"
              [showRowLines]="true"
              [showColumnLines]="true"
              [dataSource]="queryData"
              (onSelectionChanged)="queryMultipleSelectionChange($event, parameter.Name, parameter.DataArgument2)"
              [width]="'100%'"
      [selection]="{
        allowSelectAll: true,
        deferred: false,
        mode: 'multiple',
        selectAllMode: 'allPages',
        showCheckBoxesMode: 'always'
      }"
              [filterRow]="{ visible: true }"
              [visible]="true"
              [columns]="queryColumns"
              [height]="isQueryScrolling ? '520' : '100%'"
              [rowAlternationEnabled]="true"
              [paging]="{ enabled: false }"
              [allowColumnResizing]="true"
              [hoverStateEnabled]="true"
              >
            </abc-grid>
          }
        </div>
      }
    }
  </div>
}
